import { useEffect } from "react"

const LG_BREAKPOINT = "(min-width: 1024px)"

type Options = {
    hideOnMobile?: boolean
}

export const useHideGladlyIcon = (
    shouldHide: boolean,
    { hideOnMobile = false }: Options = {}
) => {
    useEffect(() => {
        if (!shouldHide && !hideOnMobile) return

        const isMobile = () => !window.matchMedia(LG_BREAKPOINT).matches

        const hideGladlyIcon = () => {
            if (hideOnMobile && !isMobile()) return
            const gladlyChatIcon = document.getElementById("gladlyChat_container")
            if (gladlyChatIcon) {
                gladlyChatIcon.style.setProperty("display", "none", "important")
            }
        }

        const showGladlyIcon = () => {
            const gladlyChatIcon = document.getElementById("gladlyChat_container")
            if (gladlyChatIcon) {
                gladlyChatIcon.style.setProperty("display", "flex", "important")
            }
        }

        // Hide immediately if element already exists
        hideGladlyIcon()

        // Watch for Gladly being injected asynchronously
        const observer = new MutationObserver(hideGladlyIcon)
        observer.observe(document.body, { childList: true, subtree: true })

        // Re-evaluate on resize when hideOnMobile is set
        const mediaQuery = hideOnMobile ? window.matchMedia(LG_BREAKPOINT) : null
        const handleMediaChange = (e: MediaQueryListEvent) => {
            if (e.matches) {
                showGladlyIcon()
            } else {
                hideGladlyIcon()
            }
        }
        mediaQuery?.addEventListener("change", handleMediaChange)

        return () => {
            observer.disconnect()
            mediaQuery?.removeEventListener("change", handleMediaChange)
            showGladlyIcon()
        }
    }, [shouldHide, hideOnMobile])
}
